import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EvaluatedcvsService {
  mainURL = 'api/';

  constructor(private http: HttpClient) {}
  getEvaluatedCvs() {
    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.get(environment.apiUrl + this.mainURL + 'scan-cv', {
      headers: headers,
    });
  }
}
